<template lang="pug">
  v-sheet(color="transparent").sdo-radius.mb-5
    file-upload(
      ref="fileUploader"
      v-bind="$attrs"
      hint="Допустимые виды файлов: png, jpg, pdf, pptx, docx, doc. Максимальный размер 64 МБ"
      vid="file"
      name="Файл"
      :invisible="image"
      :existing-file-name="fileName"
      :existing-file-url="extendUrl"
      :accept="image ? 'image/png, image/jpeg' : undefined"
      @file:changed="onChangedFile"
    )
      template(#default="{ pickfile, progress }")
        v-img(
          v-if="image"
          max-height="150"
          :src="url || require('@/assets/bg-course.svg?inline')"
        ).image
          .image-overlay(
            @click="pickfile"
          )
            v-progress-circular(
              v-if="loading"
              size=60
              color="secondary"
              width=30
              :value="progress"
            )
            v-icon(
              v-else
              large
            ) mdi-camera
        //- .caption.mt-2.grey--text Допустимые виды файлов: png, jpg. Максимальный размер 64 МБ
</template>

<script>
import FileUpload from '@/components/InputFields/FileUpload.vue';

export default {
  name: 'FileInput',
  components: {
    FileUpload,
  },
  props: {
    value: { type: [Object, String], default: null },
    image: { type: Boolean, default: false },
    originalName: { type: String, default: null },
    url: { type: String, default: null },
  },
  data() {
    return {
      loading: false,
      extendUrl: this.url,
      name: this.originalName,
    };
  },
  computed: {
    fileName() {
      if (typeof this.value === 'string' || this.originalName) {
        return this.value || this.originalName;
      }
      return this.name || '';
    },
  },
  // watch: {
  //   value: {
  //     handler(val) {
  //       if (val && typeof val === 'object') {
  //         this.extendUrl = val.url;
  //         this.$nextTick(() => {
  //           this.setFile(val);
  //         });
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  created() {
    if (this.value && typeof this.value === 'object') {
      this.extendUrl = this.value.url;
      this.name = this.value.original_name || this.value.name;
    }
  },
  methods: {
    onChangedFile(f) {
      if (f) {
        this.uploadCurrenFile();
      } else {
        this.setFile(null);
      }
    },
    setFile(file) {
      if (file) {
        this.extendUrl = file.url;
        this.$emit('input', file.file_name);
        this.$emit('change', file.file_name);
        this.$emit('update:url', file.url);
      } else {
        this.url = null;
        this.$emit('input', null);
        this.$emit('change', null);
        this.$emit('update:url', null);
      }
    },
    async uploadCurrenFile() {
      this.loading = true;
      await this.$refs.fileUploader.uploadFile()
        .then((file) => {
          this.setFile(file);
        }).catch(() => {});

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 3px dashed rgba($secondary-color, .5);

  .image-overlay {
    cursor: pointer;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    z-index: 5;

    opacity: .5;
    transition: opacity 0.3s;

    &.loading {
      opacity: 1;
    }
  }

  &:hover {
    .image-overlay {
      opacity: 1;
    }
  }
}
</style>
